var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostelImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hostel-svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4069 77.625H3C1.89543 77.625 1 76.7296 1 75.625V72.125C1 71.0204 1.89543 70.125 3 70.125H75.875C76.9796 70.125 77.875 71.0204 77.875 72.125V75.625C77.875 76.7296 76.9796 77.625 75.875 77.625H46.4684",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1875 9.93751C73.1875 8.83294 72.2921 7.93751 71.1875 7.93751H7.6875C6.58293 7.93751 5.6875 8.83294 5.6875 9.93751V68.125C5.6875 69.2296 6.58293 70.125 7.6875 70.125H71.1875C72.2921 70.125 73.1875 69.2296 73.1875 68.125V9.93751Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1145 5.9375C60.1145 7.04207 59.219 7.9375 58.1145 7.9375H20.7603C19.6557 7.9375 18.7603 7.04207 18.7603 5.9375V2.75C18.7603 1.64543 19.6557 0.75 20.7603 0.75H58.1145C59.219 0.75 60.1145 1.64543 60.1145 2.75V5.9375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4375 47.9375C33.2242 47.9375 28.1875 52.9744 28.1875 59.1875V68.125C28.1875 69.2296 29.0829 70.125 30.1875 70.125H48.6875C49.7921 70.125 50.6875 69.2296 50.6875 68.125V59.1875C50.6875 52.9744 45.6506 47.9375 39.4375 47.9375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4375 47.9375V70.125",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 23.4375C20.6875 24.5421 19.7921 25.4375 18.6875 25.4375H15.1875C14.0829 25.4375 13.1875 24.5421 13.1875 23.4375V19.9375C13.1875 18.8329 14.0829 17.9375 15.1875 17.9375H18.6875C19.7921 17.9375 20.6875 18.8329 20.6875 19.9375V23.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6875 23.4375C35.6875 24.5421 34.7921 25.4375 33.6875 25.4375H30.1875C29.0829 25.4375 28.1875 24.5421 28.1875 23.4375V19.9375C28.1875 18.8329 29.0829 17.9375 30.1875 17.9375H33.6875C34.7921 17.9375 35.6875 18.8329 35.6875 19.9375V23.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6875 23.4375C50.6875 24.5421 49.7921 25.4375 48.6875 25.4375H45.1875C44.0829 25.4375 43.1875 24.5421 43.1875 23.4375V19.9375C43.1875 18.8329 44.0829 17.9375 45.1875 17.9375H48.6875C49.7921 17.9375 50.6875 18.8329 50.6875 19.9375V23.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6875 23.4375C65.6875 24.5421 64.7921 25.4375 63.6875 25.4375H60.1875C59.0829 25.4375 58.1875 24.5421 58.1875 23.4375V19.9375C58.1875 18.8329 59.0829 17.9375 60.1875 17.9375H63.6875C64.7921 17.9375 65.6875 18.8329 65.6875 19.9375V23.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 38.4375C20.6875 39.5421 19.7921 40.4375 18.6875 40.4375H15.1875C14.0829 40.4375 13.1875 39.5421 13.1875 38.4375V34.9375C13.1875 33.8329 14.0829 32.9375 15.1875 32.9375H18.6875C19.7921 32.9375 20.6875 33.8329 20.6875 34.9375V38.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6875 38.4375C35.6875 39.5421 34.7921 40.4375 33.6875 40.4375H30.1875C29.0829 40.4375 28.1875 39.5421 28.1875 38.4375V34.9375C28.1875 33.8329 29.0829 32.9375 30.1875 32.9375H33.6875C34.7921 32.9375 35.6875 33.8329 35.6875 34.9375V38.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6875 38.4375C50.6875 39.5421 49.7921 40.4375 48.6875 40.4375H45.1875C44.0829 40.4375 43.1875 39.5421 43.1875 38.4375V34.9375C43.1875 33.8329 44.0829 32.9375 45.1875 32.9375H48.6875C49.7921 32.9375 50.6875 33.8329 50.6875 34.9375V38.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6875 38.4375C65.6875 39.5421 64.7921 40.4375 63.6875 40.4375H60.1875C59.0829 40.4375 58.1875 39.5421 58.1875 38.4375V34.9375C58.1875 33.8329 59.0829 32.9375 60.1875 32.9375H63.6875C64.7921 32.9375 65.6875 33.8329 65.6875 34.9375V38.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 53.4375C20.6875 54.5421 19.7921 55.4375 18.6875 55.4375H15.1875C14.0829 55.4375 13.1875 54.5421 13.1875 53.4375V49.9375C13.1875 48.8329 14.0829 47.9375 15.1875 47.9375H18.6875C19.7921 47.9375 20.6875 48.8329 20.6875 49.9375V53.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6875 53.4375C65.6875 54.5421 64.7921 55.4375 63.6875 55.4375H60.1875C59.0829 55.4375 58.1875 54.5421 58.1875 53.4375V49.9375C58.1875 48.8329 59.0829 47.9375 60.1875 47.9375H63.6875C64.7921 47.9375 65.6875 48.8329 65.6875 49.9375V53.4375Z",
    stroke: "#344563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostelImg);
export default __webpack_public_path__ + "static/media/hostelImg.070feb0e.svg";
export { ForwardRef as ReactComponent };